<template>
    <div class="slack-editor">
        <div class="slack-editor-wrap">
            <div
                class="slack-editor-box"
                ref="editor"
                contenteditable="true"
                @click="handle_click"
                @input="handle_input"
                @keydown="handle_key"
                @keydown.enter="$emit('enter')"
                @keydown.shift.enter.exact="handle('shift-enter', $event)"
                @keydown.enter.exact="$emit('submit', $event)"
                @keydown.down="$emit('keydown', $event)"
                @keydown.tab="$emit('tab', $event)"
                @keydown.up="$emit('keyup', $event)"
            ></div>
            <div
                class="slack-editor-placeholder"
                v-if="show_placeholder"
            >
                {{ placeholder }}
            </div>
        </div>
        <div class="slack-editor-toolbar">
            <div class="slack-bar-left">
                <button
                    :class="['slack-fmt-btn', { active: style.bold }]"
                    @click="handle('bold')"
                >
                    <o-icon
                        icon="bold"
                        size="is-small"
                    ></o-icon>
                </button>
                <button
                    :class="['slack-fmt-btn', { active: style.italic }]"
                    @click="handle('italic')"
                >
                    <o-icon
                        icon="italic"
                        size="is-small"
                    ></o-icon>
                </button>
                <button
                    :class="['slack-fmt-btn', { active: style.strike }]"
                    @click="handle('strikethrough')"
                >
                    <o-icon
                        icon="strikethrough"
                        size="is-small"
                    ></o-icon>
                </button>
                <button
                    :class="['slack-fmt-btn', { active: style.code }]"
                    @click="handle('code')"
                >
                    <o-icon
                        icon="code"
                        size="is-small"
                    ></o-icon>
                </button>
                <button
                    style="display: none"
                    :class="['slack-fmt-btn', { active: types.link }]"
                    @click="handle('link')"
                >
                    <o-icon
                        icon="link"
                        size="is-small"
                    ></o-icon>
                </button>
                <button
                    :class="['slack-fmt-btn', { active: types.ol }]"
                    @click="handle('insertorderedlist')"
                >
                    <o-icon
                        icon="list-ol"
                        size="is-small"
                    ></o-icon>
                </button>
                <button
                    :class="['slack-fmt-btn', { active: types.ul }]"
                    @click="handle('insertunorderedlist')"
                >
                    <o-icon
                        icon="list-ul"
                        size="is-small"
                    ></o-icon>
                </button>
                <button
                    :class="['slack-fmt-btn', { active: types.code }]"
                    @click="handle('quote-left')"
                >
                    <o-icon
                        icon="quote-left"
                        size="is-small"
                    ></o-icon>
                </button>
                <button
                    class="c-button-unstyled c-icon_button c-icon_button--light c-icon_button--size_small c-wysiwyg_container__button"
                    data-qa="texty_emoji_button"
                    tabindex="-1"
                    aria-label="Emoji"
                    aria-haspopup="dialog"
                    aria-expanded="false"
                    delay="500"
                    data-sk="tooltip_parent"
                    type="button"
                    @click="show_emoji_picker"
                ><i
                        class="c-icon c-icon--smile-o"
                        type="smile-o"
                        aria-hidden="true"
                    ></i></button>
              <button class="slack-fmt-btn" @click="openModalFile">
                <o-icon
                    icon="file"
                    size="is-small"
                >
                </o-icon>
              </button>
            </div>
            <div
                class="c-wysiwyg_container__suffix"
                data-qa="wysiwyg-container_suffix"
            ><span class="c-wysiwyg_container__send_button--with_options">
                    <button
                        class="c-button-unstyled c-icon_button c-icon_button--light c-icon_button--size_small c-wysiwyg_container__button c-wysiwyg_container__button--send"
                        tabindex="0"
                        aria-disabled="false"
                        data-qa="texty_send_button"
                        aria-label="Send now"
                        delay="150"
                        data-sk="tooltip_parent"
                        type="button"
                        @click="$emit('submit_button', $event)"
                    ><i
                            class="c-icon c-icon--paperplane-filled"
                            type="paperplane-filled"
                            aria-hidden="true"
                        ></i>
                    </button>
                </span>
            </div>
        </div>
        <slack-emoji-picker
            ref="emoji_picker"
            @selected="handle_add_emoji"
        />
      <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isFileCard" has-modal-card>
        <file-send-modal/>
      </o-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { build_message, get_parent, toggle_code, get_text_nodes, has_parent } from './editor_utils'
import SlackEmojiPicker from '../emoji-picker/SlackEmojiPicker'
import {post_file} from "../../slack_api";
export default {
    components: {
        SlackEmojiPicker,
    },
    computed: {
        ...mapGetters([
            'slack_channels',
            'slack_users',
        ]),
        editor() {
            return this.$refs.editor
        },
        show_placeholder() {
            return !!this.placeholder
        },
    },
    data() {
        return {
            filtered_users: [],
            popup_style: { transform: 'translate(-32px,-100%)' },
            previous_text: '',
            search_term: '',
            selected: 0,
            style: {},
            show_popup: false,
            text: this.value,
            types: {},
            users: [],
            isFileCard: false
        }
    },
    methods: {

      openModalFile(){
        this.isFileCard = true
      },
        handle_add_emoji(e) {
            this.$emit('selected_emoji', e)
            this.$refs.emoji_picker.hide()
        },
        handle(type, e) {
            let editor, node, r, s
            switch (type) {
                case 'bold':
                case 'insertorderedlist':
                case 'insertunorderedlist':
                case 'italic':
                case 'strikethrough':
                    document.execCommand(type)
                    break
                case 'code':
                    s = window.getSelection()
                    if (s.isCollapsed) {
                        break
                    }
                    editor = this.$refs.editor
                    toggle_code(editor)
                    break
                case 'quote-left':
                    editor = this.$refs.editor
                    s = window.getSelection()
                    node = s.getRangeAt(0).startContainer
                    const active = has_parent('pre', node, editor)
                    document.execCommand('formatBlock', false, active ? 'div' : 'pre')
                    break
                case 'shift-enter':
                    s = window.getSelection()
                    r = s.getRangeAt(0)
                    node = r.startContainer
                    if (has_parent('li', node, this.$refs.editor)) {
                        e.preventDefault()
                        const li = get_parent('li', node, this.$refs.editor)
                        const li_text_nodes = get_text_nodes(li)
                        const last_text_node = li_text_nodes[li_text_nodes.length - 1]
                        r.setEnd(last_text_node, last_text_node.data.length)
                        const new_li = document.createElement('li')
                        const contents = r.extractContents()
                        li.after(new_li)
                        if (contents.childElementCount === 0) {
                            new_li.appendChild(document.createTextNode(contents.textContent))
                            const new_idx = Array.from(li.parentElement.childNodes).findIndex(n => n.isSameNode(new_li))
                            r.setStart(li.parentElement, new_idx)
                        } else {
                            new_li.appendChild(contents)
                            r.setStart(get_text_nodes(new_li)[0], 0)
                        }
                        r.collapse(true)
                    }
                    break
            }
        },
        handle_click() {
            this.update_controls()
        },
        handle_input(e) {
            this.$emit('input', e, build_message(this.$refs.editor))
        },
        handle_key(e) {
            if (e.key === 'Escape') {
                this.$emit('escape', e)
            }
            this.update_controls()
        },
        show_emoji_picker(e) {
            this.$refs.emoji_picker.show(e)
        },
        update_controls() {
            const editor = this.$refs.editor, style = {}
            let node = window.getSelection().anchorNode
            this.types = {}
            do {
                switch (node && node.parentElement && node.parentElement.tagName) {
                    case 'B':
                    case 'STRONG':
                        style.bold = true
                        break
                    case 'CODE':
                        style.code = true
                        break
                    case 'EM':
                    case 'I':
                        style.italic = true
                        break
                    case 'LINK':
                        this.types.link = true
                        break
                    case 'OL':
                        this.types.ol = true
                        break
                    case 'STRIKE':
                        style.strike = true
                        break
                    case 'UL':
                        this.types.ul = true
                        break
                }
                node = node && node.parentElement
            } while (node && !node.isSameNode(editor))
            this.style = style
        },
    },
    mounted() {
    },
    props: ['placeholder', 'value'],
}
</script>
<style>
.slack-editor {
  border: 1px solid #868686;
  border-radius: 4px;
  position: relative; }
.slack-editor .slack-editor-wrap .slack-editor-box {
  background-color: white;
  border: none;
  border-radius: 4px;
  padding: 8px; }
.slack-editor .slack-editor-wrap .slack-editor-box:focus {
  outline: none; }
.slack-editor .slack-editor-wrap .slack-editor-box > p {
  min-height: 22px; }
.slack-editor .slack-editor-wrap .slack-editor-box .slack-mention {
  border: none; }
.slack-editor .slack-editor-wrap .slack-editor-box .slack-mention .slack-mention-content {
  background-color: #06212d;
  border: none;
  border-radius: 3px;
  color: #1264a3;
  margin: 0 6px;
  padding: 0 2px 1px 2px; }
.slack-editor .slack-editor-wrap .slack-editor-box .slack-mention .slack-mention-content.me {
  background-color: #f2c74466; }
.slack-editor .slack-editor-wrap .slack-editor-box code {
  border: 1px solid #343234;
  border-radius: 3px;
  color: #e01e5a;
  font-size: 14px;
  font-variant-ligatures: none;
  line-height: 1.50001;
  padding: 2px 3px 1px;
  tab-size: 4;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: normal; }
.slack-editor .slack-editor-wrap .slack-editor-box ol, .slack-editor .slack-editor-wrap .slack-editor-box ul {
  list-style-type: none; }
.slack-editor .slack-editor-wrap .slack-editor-box ol li:before, .slack-editor .slack-editor-wrap .slack-editor-box ul li:before {
  display: inline-block;
  margin-left: -24px;
  text-align: center;
  width: 24px; }
.slack-editor .slack-editor-wrap .slack-editor-box ol {
  counter-reset: list-0;
  margin: 0px;
  padding: 0px; }
.slack-editor .slack-editor-wrap .slack-editor-box ol li {
  counter-increment: list-num;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  margin-left: 26px; }
.slack-editor .slack-editor-wrap .slack-editor-box ol li:before {
  counter-increment: list-0;
  content: counter(list-0, decimal) "."; }
.slack-editor .slack-editor-wrap .slack-editor-box ul {
  margin: 0px;
  padding: 0px; }
.slack-editor .slack-editor-wrap .slack-editor-box ul li {
  margin-left: 26px; }
.slack-editor .slack-editor-wrap .slack-editor-box ul li:before {
  content: "\f111";
  font-family: 'FontAwesome';
  font-size: 10px;
  font-weight: 400; }
.slack-editor .slack-editor-wrap .slack-editor-placeholder {
  left: 8px;
  opacity: 0.5;
  pointer-events: none;
  position: absolute;
  top: 8px; }
.slack-editor .slack-editor-toolbar {
  align-items: center;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top: 1px;
  display: flex;
  justify-content: space-between;
  transition: background 80ms,border-color 80ms; }
.slack-editor .slack-editor-toolbar .slack-bar-left {
  display: flex;
  padding: 4px; }
.slack-editor .slack-editor-toolbar .slack-bar-left .slack-fmt-btn {
  background: transparent;
  border: none;
  border-radius: 2px;
  height: 32px;
  margin-right: 1px;
  text-align: center;
  width: 32px; }
.slack-editor .slack-editor-toolbar .slack-bar-left .slack-fmt-btn:hover {
  background-color: #1d1c1d; }
.slack-editor .slack-editor-toolbar .slack-bar-left .slack-fmt-btn.active {
  background-color: #343234; }
.slack-editor .slack-editor-toolbar .slack-bar-left .slack-fmt-btn.active:hover {
  background-color: #1d1c1d; }
.slack-editor .c-wysiwyg_container__button.c-wysiwyg_container__button--send, .slack-editor .c-wysiwyg_container__button.c-wysiwyg_container__button--send_options {
  background: #007a5a;
  color: #fff; }
.slack-editor .c-wysiwyg_container {
  margin-right: 6px; }
.slack-editor .c-wysiwyg_container .c-wysiwyg_container__button, .slack-editor .c-wysiwyg_container .c-wysiwyg_container .p-composer__button--sticky.c-icon_button, .slack-editor .c-wysiwyg_container .p-texty_floating_formatting_bar .p-composer__button--floating.c-icon_button {
  height: 28px;
  width: 28px;
  padding: 2px;
  margin: 2px;
  border-radius: 4px; }

</style>